<template>
    <b-modal v-model="showModal" size="xl" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
        :title="prefix + ' ' + title">
        <b-card bg-variant="light">
            <div class="d-flex align-items-center justify-content-center">
                <strong>{{ almoxarifado.descricao }}</strong>
            </div>
        </b-card>

        <b-tabs>
            <b-tab title="Produtos">
                <TabProduto :prefix="prefix + ' ' + title + ' > '" :almoxarifado="almoxarifado"></TabProduto>
            </b-tab>
            <b-tab title="Unidade Administrativa">
                <TabUnidadeAdministrativa @close="cancelar" :almoxarifado="almoxarifado"></TabUnidadeAdministrativa>
            </b-tab>
        </b-tabs>

    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource";
import TabUnidadeAdministrativa from "./TabUnidadeAdministrativa.vue";
import TabProduto from "./TabProduto.vue";

export default {
    components: {
        TabUnidadeAdministrativa,
        TabProduto,
    },
    props: {
        almoxarifado: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Configuração Almoxarifado",
        },
        currentSubgrupo: Object,
    },
    data() {
        return {
            selecionado: false,
            almoxarifados: [],
            showModal: true,
            form: {
                classe: {},
            },
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin],

    async beforeMount() {
        this.$service = new ResourceService('/api/almoxarifado');
        this.load();
    },
    methods: {
        async load() {
            this.busy = true;
            this.busy = false;

        },

        cancelar() {
            this.$emit("close")
        },
    },

}
</script>